var React = require('react');

function Comparison (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M107.2,180.3H15.1c-3.3,0-5.5,2.2-5.5,5.5v16.5c0,3.3,2.2,5.5,5.5,5.5h93.3c3.3,0,5.5,2.2,5.5,5.5v28.5\n\t\tc0,4.4,5.5,6.6,8.8,3.3l47.2-47.2c2.2-2.2,2.2-5.5,0-7.7L122.6,143c-3.3-3.3-8.8-1.1-8.8,3.3v28.5\n\t\tC112.7,178.1,110.5,180.3,107.2,180.3z M169.8,136.4v-28.5c0-3.3,2.2-5.5,5.5-5.5h93.3c3.3,0,5.5-2.2,5.5-5.5V81.6\n\t\tc0-3.3-2.2-5.5-5.5-5.5h-93.3c-3.3,0-5.5-2.2-5.5-5.5V43.2c0-4.4-5.5-6.6-8.8-3.3L113.8,86c-2.2,2.2-2.2,5.5,0,7.7l47.2,47.2\n\t\tC164.3,143,169.8,140.8,169.8,136.4z"})));
}

Comparison.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 283.5 283.5","style":{"enableBackground":"new 0 0 283.5 283.5"},"xmlSpace":"preserve"};

module.exports = Comparison;

Comparison.default = Comparison;
